import { render, staticRenderFns } from "./EditCountry.vue?vue&type=template&id=1adf5a18&scoped=true&"
import script from "./EditCountry.vue?vue&type=script&lang=js&"
export * from "./EditCountry.vue?vue&type=script&lang=js&"
import style0 from "./EditCountry.vue?vue&type=style&index=0&id=1adf5a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf5a18",
  null
  
)

export default component.exports